import CloseIcon from "@mui/icons-material/Close";
import { Button, DialogContent, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import FileUpload from "./FileUpload";

interface Props {
  onClose?: () => void;
  onSubmit?: (files: File[]) => void;
  disableMultiple?: boolean;
}

export const FileImportDialog = ({
  onClose,
  onSubmit,
  disableMultiple = false,
}: Props): JSX.Element => {
  const { t } = useTranslation("file-explorer");

  const [files, setFiles] = React.useState<File[]>([]);

  const onAddFiles = useCallback(() => {
    onSubmit?.(files);
    onClose?.();
  }, [files, onClose, onSubmit]);

  return (
    <DialogContent>
      <Box
        sx={{
          display: "grid",
          gridTemplateRows: "95% 5%",
          width: "100%",
          height: { xs: "100vh", md: "60vh" },
        }}
      >
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <FileUpload
            options={{
              onDrop: (x: File[]) => setFiles(x),
              multiple: !disableMultiple,
            }}
            uploadProgress={undefined}
            minHeight="30%"
          />
          {files.length > 0 && (
            <Box height="70%">
              <Typography variant="h6">{t("seleted-files")}</Typography>
              <Box sx={{ maxHeight: "90%", overflowY: "auto" }}>
                {files.map((x) => (
                  <Box key={x.name}>
                    {x.name}
                    <IconButton
                      onClick={() =>
                        setFiles((f) => [...f.filter((d) => x !== d)])
                      }
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button disabled={files.length === 0} onClick={onAddFiles}>
            {t("general:add")}
          </Button>
          <Button onClick={onClose}>{t("general:cancel")}</Button>
        </Box>
      </Box>
    </DialogContent>
  );
};
